"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = exports.MobileBannerWrapper = exports.DesktopBannerWrapper = exports.Link = exports.TextContent = exports.Covid19BannerWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Covid19BannerWrapper = _styledComponents.default.div.attrs({
  "data-qa": "covid-19-banner-wrapper"
}).withConfig({
  displayName: "Covid19Bannerstyles__Covid19BannerWrapper",
  componentId: "sc-1hjexy7-0"
})(["display:flex;align-items:center;justify-content:center;padding:14px 0;background:#e9f1f6;font-size:16px !important;.is-bold{font-weight:bold;}@media (max-width:", "px){padding:12px;font-size:13px !important;}"], function (props) {
  return props.theme.breakpoints.values.sm;
});

exports.Covid19BannerWrapper = Covid19BannerWrapper;

var TextContent = _styledComponents.default.div.attrs({
  "data-qa": "text-content"
}).withConfig({
  displayName: "Covid19Bannerstyles__TextContent",
  componentId: "sc-1hjexy7-1"
})(["margin-left:8px;"]);

exports.TextContent = TextContent;

var Link = _styledComponents.default.a.attrs({
  "data-qa": "link"
}).withConfig({
  displayName: "Covid19Bannerstyles__Link",
  componentId: "sc-1hjexy7-2"
})(["display:inline;white-space:nowrap;color:", ";&:hover{color:", ";cursor:pointer;}"], function (props) {
  return props.theme.carvana.blue.primary;
}, function (props) {
  return props.theme.carvana.blue.hover;
});

exports.Link = Link;

var DesktopBannerWrapper = _styledComponents.default.span.attrs({
  "data-qa": "desktop-banner-wrapper"
}).withConfig({
  displayName: "Covid19Bannerstyles__DesktopBannerWrapper",
  componentId: "sc-1hjexy7-3"
})(["display:none;@media (min-width:", "px){display:flex;align-items:center;}"], function (props) {
  return props.theme.breakpoints.values.sm;
});

exports.DesktopBannerWrapper = DesktopBannerWrapper;

var MobileBannerWrapper = _styledComponents.default.div.attrs({
  "data-qa": "mobile-banner-wrapper"
}).withConfig({
  displayName: "Covid19Bannerstyles__MobileBannerWrapper",
  componentId: "sc-1hjexy7-4"
})(["display:none;@media (max-width:", "px){display:flex;}"], function (props) {
  return props.theme.breakpoints.values.sm;
});

exports.MobileBannerWrapper = MobileBannerWrapper;

var Image = _styledComponents.default.img.attrs({
  "data-qa": "image"
}).withConfig({
  displayName: "Covid19Bannerstyles__Image",
  componentId: "sc-1hjexy7-5"
})([""]);

exports.Image = Image;